import React, { useState, useEffect } from 'react';
import crypto from 'crypto'
import './LaunchSites.scss'
import SiteDescription from './SiteDescription'
import PersonAvatar from '../../../components/models/Launch/common/PersonAvatar/PersonAvatar'
import SvgWorldMap from './SvgWorldMap'
import SvgLocationPoint from './SvgWorldMap/SvgLocationPoint';
import StartScreen from '../../../components/models/Launch/common/StartScreen'
import Button from '../Button/Button'
import Modal from "../../partials/Modal/SimpleModal/SimpleModal";
import useDimensions from "../../../hooks/useDimensions"



const LaunchSites = (props) => {

  const {rocketrep, locations, onChoosedLocation} = props;
  
  
  const [startScreen, setStartScreen] = useState(true)
  const [launchSite, setLaunchSite] = useState(false)
  const [showDescription, setShowDescription] = useState(false)
  const [choosedLocation, setChoosedLocation] = useState()
  const [viewPortRef, viewPort] = useDimensions(true);
  const [siteDescRef, siteDesc] = useDimensions(true);


    /**
     * Calculate Position of Elements
     * @param {*} e 
     * @returns 
     */
    const calcPos = (e) =>{
      
      const offsetConst= 15;
      const point = e.currentTarget.getBoundingClientRect();

      const offsetX = point.left - (viewPort.x) + offsetConst;
      const offsetY = point.top - (viewPort.y) + offsetConst;

      const x = offsetX > 580 ? offsetX - siteDesc.width : offsetX;
      const y = offsetY > 360 ? offsetY - (siteDesc.height ? siteDesc.height:200) : offsetY;


      return  { x, y }
    }

    /**
     * Generate a Location Site ID
     * @param {*} str 
     * @returns 
     */
    const genSiteId = (str) => {
      const string = str.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'')
      return crypto.createHash('sha1').update(string).digest('hex');
    }

    /**
     * Start Button Handle
     */
    const onStartClickHandle = () => {
      setStartScreen(false)
    }

    /**
     * Render Locations Arrays
     * @param {*} locationsArray 
     * @returns React.Component
     */
    const renderLocations = (locationsArray) => {
      return (
        locationsArray.map((location, index) => {
          const siteId = genSiteId(location.name);
          return <SvgLocationPoint
            key={index}
            disabled={startScreen}
            id={siteId}
            x={location.coords.x}
            y={location.coords.y}
            onClick={(siteId)=>onLocationClickHandle(siteId)}
            r='32' />
        }
      )
    )}
    
    const setLaunchSiteState = (launchSite, show) => {

      setLaunchSite(launchSite)
      setShowDescription(show)

    }
    /** 
     * Location Click Handle
     */
    const onLocationClickHandle = (e) => {
      
      const id = e.target.id

      if(launchSite && launchSite.id === id) {
        setLaunchSiteState(false, false)
      }
      else{
        
        const pos = calcPos(e)
        const result = locations.find( location => genSiteId(location.name)===id )
        const show = true

        setLaunchSiteState({ ...result, pos, id, show }, true)
      }

    }


    const onCloseHandle = ()=>{
      setChoosedLocation(false)
    }

    const onChooseHandle = () => {
      setChoosedLocation(launchSite)
      // onChoosedLocation(launchSite)
      setLaunchSiteState(false, false)
    }

    // e.clientY
    return (
    <>
      <div className="launch-sites" ref={viewPortRef}>

        <div className={`launch-sites-grid persons item shrink ${ startScreen ? 'visible' : 'hidden'}`}>

          {rocketrep.map((rep, index)=> (
            <PersonAvatar 
              key={index} 
              avatar={rep.avatar}  
              avatarAlt={rep.avatarAlt || rep.name}
              name={rep.name}  
              speak={rep.repSpeech}
              jobtitle={rep.role}
              /> 
            ))
          }
        </div>

        <div className={`launch-sites-grid item shrink ${ showDescription ? 'visible' : 'hidden'}`}>
          {launchSite && 
            <SiteDescription location={launchSite} refObj={siteDescRef} > 
                <Button 
                  text='Choose Site' 
                  className='primary small expand' 
                  onClick={onChooseHandle} />
            </SiteDescription> }
        </div>
        
        <div className="launch-sites-grid item canvas" >

          { startScreen && 
            <div className="bottom-right"><Button text='Start' size='small' onClick={onStartClickHandle} /></div>
          }

          <SvgWorldMap style={{opacity:startScreen ? 0.2 : 1, overflow:`visible`}} className="fixed-area" locations={renderLocations(locations)}/>
        </div>
        
      </div>

      {choosedLocation  &&
        <Modal show={choosedLocation ? true : false} size="small">
          <PersonAvatar 
              avatar={rocketrep[0].avatar}  
              name={rocketrep[0].name}  
              speak={choosedLocation.feedback}
              jobtitle={rocketrep[0].role}
              /> 

              <Button 
                  text='Keep Looking' 
                  className='small expand' 
                  onClick={onCloseHandle} /> 
            
            {choosedLocation.correct &&
              <Button 
                  text='Confirm Launch Site' 
                  className='success expand' 
                  onClick={()=>onChoosedLocation(choosedLocation)} />
            }
        </Modal>
      }
    </>
    );
}
export default LaunchSites;